import { addProductToBusinessReturnCommand } from './addProductToBusinessReturnCommand';
import createOrderAndShareLinkByProductReferenceCommand from './createOrderAndShareLinkByProductReferenceCommand';
import { createOrderByProductReferenceCommand } from './createOrderByProductReferenceCommand';
import getOrderByOwnerId from './getOrderByOwnerId';
import getOrderDetailsQuery from './getOrderDetailsQuery';
import getProductFullInformations from './getProductFullInformations';
import getProductsByOwnerId from './getProductsByOwnerId';
import { getVideoSessionPublisherTokenQuery } from './getVideoSessionPublisherTokenQuery';
import listOwnerProductsQuery from './listOwnerProductsQuery';
import { removeProductToBusinessReturnCommand } from './removeProductToBusinessReturnCommand';
import { setProductToBusinessReturnCommand } from './setProductToBusinessReturnCommand';
import { startOrContinueBusinessReturnCommand } from './startOrContinueBusinessReturnCommand';

export const OwnerService = {
  getProductFullInformations,
  getOrderByOwnerId,
  getOrderDetailsQuery,
  getProductsByOwnerId,
  listOwnerProductsQuery,
  createOrderAndShareLinkByProductReferenceCommand,
  startOrContinueBusinessReturnCommand,
  setProductToBusinessReturnCommand,
  addProductToBusinessReturnCommand,
  removeProductToBusinessReturnCommand,
  getVideoSessionPublisherTokenQuery,
  createOrderByProductReferenceCommand,
};
